import type { TOC } from '@ember/component/template-only';
import type { PowerSelectOptionsSignature } from 'ember-power-select/components/power-select/options';
import PowerSelectOptions from 'ember-power-select/components/power-select/options';
import { not } from 'ember-truth-helpers';

import type {
  Group,
  Option,
} from '../../../../types/components/prism/combo-select-input.ts';
import PrismComboSelectInputUnsafeInfiniteScrollContainer from './infinite-scroll-container.gts';

interface PrismComboSelectInputUnsafeInfiniteScrollOptionsArgs {
  onLoadMore: () => unknown;
}

interface PrismComboSelectInputUnsafeInfiniteScrollOptionsSignature extends PowerSelectOptionsSignature<
  Option,
  Group<Option>
> {
  Args: PowerSelectOptionsSignature<Option, Group<Option>>['Args'] &
    PrismComboSelectInputUnsafeInfiniteScrollOptionsArgs;
  Element: HTMLUListElement;
}

/**
 * Simple wrapper component that takes the `onLoadMore` function and calls it when the user scrolls to the bottom of the list.
 */
const PrismComboSelectInputUnsafeInfiniteScrollOptions = <template>
  {{!
  The options component is rendered multiple times when there are groups, and there should only be one InfiniteScroller component
  as the parent, hence why we check if we're in a group here and perform a normal render
}}
  <PrismComboSelectInputUnsafeInfiniteScrollContainer
    @isInfiniteScrollEnabled={{not @groupIndex}}
    @onLoadMore={{@onLoadMore}}
    @percent={{50}}
    class="dropdown__unsafe-infinite-scroll-options"
  >
    {{! 
      Required props to be passed to the default Options component
      @see https://github.com/cibernox/ember-power-select/blob/858a96d08467231ffaa84acdb6dd5eac57e89e45/ember-power-select/src/components/power-select.hbs#L167-179
    }}
    <PowerSelectOptions
      @groupComponent={{@groupComponent}}
      @groupIndex={{@groupIndex}}
      @highlightOnHover={{@highlightOnHover}}
      @loadingMessage={{@loadingMessage}}
      @options={{@options}}
      @optionsComponent={{@optionsComponent}}
      @select={{@select}}
      class="ember-power-select-options unsafe-infinite-scroll-options__ember-power-select-options"
      ...attributes
      as |option select|
    >
      {{yield option select}}
    </PowerSelectOptions>
  </PrismComboSelectInputUnsafeInfiniteScrollContainer>
</template> satisfies TOC<PrismComboSelectInputUnsafeInfiniteScrollOptionsSignature>;

export default PrismComboSelectInputUnsafeInfiniteScrollOptions;
